// in milliseconds
export const animationDuration = 200;
